import { watch } from "vue";
import { i as isServer } from "../../../utils/ssr.js";
import { j as cssVariableName } from "../utils.js";

import { u as useColors } from "../../../composables/useColors.js";




const setCSSVariable = (name, value, root) => {
  root.style.setProperty(cssVariableName(name), value);
};
const createColorConfigPlugin = (app, config) => {
  var _a;
  const { colors, getTextColor, getColor, currentPresetName, applyPreset } = useColors();
  const renderCSSVariables = (colors2) => {
    if (!colors2) {
      return;
    }
    const colorNames = Object.keys(colors2);
    return colorNames.map((key) => `${cssVariableName(key)}: ${colors2[key]}`).join(";");
  };
  const updateColors = (newValue) => {
    if (!newValue) {
      return;
    }
    if (isServer()) {
      return;
    }
    const root = document.documentElement;
    const colorNames = Object.keys(newValue);
    colorNames.forEach((key) => {
      setCSSVariable(key, newValue[key], root);
    });
    colorNames.forEach((key) => {
      setCSSVariable(`on-${key}`, getColor(getTextColor(newValue[key])), root);
    });
  };
  watch(colors, (newValue) => {
    updateColors(newValue);
  }, { immediate: true, deep: true });
  if ((_a = config == null ? void 0 : config.colors) == null ? void 0 : _a.currentPresetName) {
    applyPreset(config.colors.currentPresetName);
  }
  return {
    renderCSSVariables,
    updateColors
  };
};
export { createColorConfigPlugin as c };
//# sourceMappingURL=create-color-config-plugin.js.map
